import unescapeHtmlTag from "../../../../../core/utils/tools";
import React from "react";
import {useSelector} from "react-redux";



const PartDetail = ({item}) => {
  const langData = useSelector(state => state.theme.langData);


  return (
    <div>
      <div className={"option-image"}>
        <img src={`${process.env.REACT_APP_image_path}/item/${item.detailImgDesktop}`}/>
      </div>
      <div className={"option-name"}>{unescapeHtmlTag(item[langData.langName])}</div>
      <div className={"option-desc"}>{unescapeHtmlTag(item[langData.langDesc])}</div>
    </div>
  )
}

export default PartDetail;
